(function () {
  var CLOSE_DELAY = 150;
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.onResize = this.updateHeight.bind(this);
        this.updateHeight();
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      updateHeight() {
        var section = this.closest('.section-header') || this;
        document.documentElement.style.setProperty('--header-height', section.offsetHeight + 'px');
      }

      reveal() {}
    }

    customElements.define('sticky-header', StickyHeader);
  }

  function init(root) {
    if (!root || root.getAttribute('data-tjm-header-ready') === 'true') return;
    root.setAttribute('data-tjm-header-ready', 'true');

    var closeTimer = null;
    var items = root.querySelectorAll('[data-tjm-menu-item]');
    var drawer = root.querySelector('[data-tjm-drawer]');
    var toggle = root.querySelector('[data-tjm-drawer-toggle]');
    var panel = root.querySelector('[data-tjm-drawer-panel]');
    var searchModal = root.querySelector('details-modal');
    var searchSummary = root.querySelector('[data-tjm-search-summary]');
    var lastFocus = null;

    function setMega(item, isOpen) {
      var mega = item.querySelector('[data-tjm-mega]');
      var trigger = item.querySelector('[data-tjm-menu-trigger]');
      if (!mega) return;
      item.classList.toggle('is-open', isOpen);
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) mega.removeAttribute('hidden');
      else mega.setAttribute('hidden', '');
    }

    function closeMegas() {
      window.clearTimeout(closeTimer);
      items.forEach(function (item) {
        setMega(item, false);
      });
    }

    function scheduleClose(item) {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        setMega(item, false);
      }, CLOSE_DELAY);
    }

    function openMega(item) {
      window.clearTimeout(closeTimer);
      items.forEach(function (other) {
        if (other !== item) setMega(other, false);
      });
      setMega(item, true);
    }

    items.forEach(function (item) {
      var mega = item.querySelector('[data-tjm-mega]');

      item.addEventListener('mouseenter', function () {
        openMega(item);
      });

      item.addEventListener('focusin', function () {
        openMega(item);
      });

      if (!mega) return;

      item.addEventListener('mouseleave', function () {
        if (item.contains(document.activeElement)) return;
        scheduleClose(item);
      });

      item.addEventListener('focusout', function (event) {
        if (item.contains(event.relatedTarget)) return;
        scheduleClose(item);
      });

      mega.addEventListener('mouseenter', function () {
        openMega(item);
      });
    });

    function focusable(container) {
      return Array.prototype.filter.call(
        container.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), summary'),
        function (node) {
          return node.tabIndex >= 0 && node.getAttribute('aria-hidden') !== 'true';
        }
      );
    }

    function trapDrawer(event) {
      if (!drawer || drawer.hasAttribute('hidden') || event.key !== 'Tab' || !panel) return;
      var nodes = focusable(drawer);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function searchIsOpen() {
      return searchModal && typeof searchModal.isOpen === 'function' && searchModal.isOpen();
    }

    function lockScroll() {
      document.body.classList.add('overflow-hidden');
    }

    function unlockScroll() {
      if (searchIsOpen()) return;
      if (drawer && !drawer.hasAttribute('hidden')) return;
      document.body.classList.remove('overflow-hidden');
    }

    function closeSearch() {
      if (searchIsOpen()) searchModal.close(false);
    }

    function openDrawer() {
      if (!drawer || DESKTOP.matches) return;
      closeMegas();
      closeSearch();
      lastFocus = document.activeElement;
      drawer.removeAttribute('hidden');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      lockScroll();
      var closeButton = drawer.querySelector('[data-tjm-drawer-close]');
      if (closeButton) closeButton.focus();
    }

    function closeDrawer(restoreFocus) {
      if (!drawer || drawer.hasAttribute('hidden')) return;
      drawer.setAttribute('hidden', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      unlockScroll();
      if (restoreFocus !== false && toggle) toggle.focus();
      else if (restoreFocus !== false && lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (drawer && drawer.hasAttribute('hidden')) openDrawer();
        else closeDrawer();
      });
    }

    if (drawer) {
      drawer.querySelectorAll('[data-tjm-drawer-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          closeDrawer();
        });
      });

      drawer.addEventListener('keydown', trapDrawer);

      drawer.querySelectorAll('.tjm-drawer__nav > details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          drawer.querySelectorAll('.tjm-drawer__nav > details').forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    }

    root.querySelectorAll('[data-tjm-open-search]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeDrawer(false);
        closeMegas();
        if (searchSummary) searchSummary.click();
      });
    });

    if (searchSummary) {
      searchSummary.addEventListener('click', function () {
        closeMegas();
      });
    }

    function syncSearchTrigger() {
      if (!searchSummary) return;
      if (DESKTOP.matches) {
        searchSummary.removeAttribute('tabindex');
        searchSummary.removeAttribute('aria-hidden');
        closeDrawer(false);
      } else {
        searchSummary.setAttribute('tabindex', '-1');
        searchSummary.setAttribute('aria-hidden', 'true');
      }
    }

    syncSearchTrigger();
    DESKTOP.addEventListener('change', syncSearchTrigger);

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (drawer && !drawer.hasAttribute('hidden')) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      var openItem = root.querySelector('[data-tjm-menu-item].is-open');
      if (!openItem) return;
      event.preventDefault();
      window.clearTimeout(closeTimer);
      setMega(openItem, false);
      var trigger = openItem.querySelector('[data-tjm-menu-trigger]');
      if (trigger) trigger.focus();
    });

    root._tjmOpenMega = openMega;
    root._tjmHeaderDestroy = function () {
      window.clearTimeout(closeTimer);
      DESKTOP.removeEventListener('change', syncSearchTrigger);
      root._tjmOpenMega = null;
      root._tjmHeaderDestroy = null;
    };
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-tjm-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-tjm-header]');
    if (root && root._tjmHeaderDestroy) root._tjmHeaderDestroy();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var promo = event.target.closest('[data-tjm-promo]');
    if (!promo) return;
    var item = promo.closest('[data-tjm-menu-item]');
    var root = promo.closest('[data-tjm-header]');
    if (item && root && root._tjmOpenMega) root._tjmOpenMega(item);
  });
})();
